import { VrLineHeight } from '../../src/theming/verticalRhythm/verticalRhythm';

export const getMockVrLineHeight: () => VrLineHeight = () => {
  return {
    '@media (min-width: 1201px)': 24,
    '@media (max-width: 1200px)': 24,
    '@media (max-width: 900px)': 24,
    '@media (max-width: 600px)': 24,
  };
};
